import React from 'react';
import { TOOLBARS, COLLAB_SECTION, TOOLBAR_RANK, COMMENT_GROUP, COLLAB_SECTION_RANK, COMMENT_HERO_BUTTON } from '@atlaskit/editor-common/toolbar';
import { CommentButton } from './CommentButton/CommentButton';
export var getToolbarComponents = function getToolbarComponents(api, annotationProviders) {
  return [{
    type: COLLAB_SECTION.type,
    key: COLLAB_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.INLINE_TEXT_TOOLBAR,
      rank: TOOLBAR_RANK[COLLAB_SECTION.key]
    }]
  }, {
    type: COMMENT_GROUP.type,
    key: COMMENT_GROUP.key,
    parents: [{
      type: COLLAB_SECTION.type,
      key: COLLAB_SECTION.key,
      rank: TOOLBAR_RANK[COLLAB_SECTION.key]
    }]
  }, {
    type: COMMENT_HERO_BUTTON.type,
    key: COMMENT_HERO_BUTTON.key,
    parents: [{
      type: COMMENT_GROUP.type,
      key: COMMENT_GROUP.key,
      rank: COLLAB_SECTION_RANK[COMMENT_GROUP.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(CommentButton, {
        api: api,
        annotationProviders: annotationProviders
      });
    }
  }];
};